export function reverseGeocodeAddress (geocoder, position) {
    return new Promise((resolve, reject) => {
        geocoder.geocode({ location: position })
            .then((response) => {
                if (response.results[0]) {
                    const components = response.results[0].address_components;
                    
                    let streetNumber = "";
                    let route = "";
                    let city = "";
                    let premise = "";
                    let neighborhood = "";
                    let state = "";

                    components.forEach(component => {
                        const types = component.types;
                        if (types.includes("street_number")) streetNumber = component.long_name;
                        if (types.includes("route")) route = component.long_name;
                        if (types.includes("locality")) city = component.long_name;
                        if (types.includes("premise") || types.includes("establishment")) premise = component.long_name;
                        if (types.includes("neighborhood") || types.includes("sublocality")) neighborhood = component.long_name;
                        if (types.includes("administrative_area_level_1")) state = component.long_name;
                    });

                    const streetLine = `${streetNumber} ${route}`.trim() 
                        || premise 
                        || neighborhood 
                        || "Unnamed Location";
                    const cityLine = city && state ? `${city}, ${state}` : (city || state);
                    
                    resolve({ address: streetLine, city: cityLine });
                } else {
                    reject("No address found for this location.");
                }
            })
            .catch((error) => reject(error));
    });
}
